export default __webpack_public_path__ + "static/media/blacklogo.e25e45af.svg";